export const genderOptions = [
  {
    name: 'Male',
    value: '1'
  },
  {
    name: 'Female',
    value: '2'
  },
  {
    name: 'Not Specified',
    value: '3'
  }
];

export function parseSearchParams(search) {
  const searchParams = new URLSearchParams(search);

  function parseParam(obj, keys, value) {
    const key = keys.shift();

    if (keys.length === 0) {
      obj[key] = value;
    } else {
      obj[key] = obj[key] || {};
      parseParam(obj[key], keys, value);
    }
  }

  const queryParamsObject = {};
  searchParams.forEach((value, key) => {
    const keys = key.split('[').map((str) => str.replace(']', ''));
    parseParam(queryParamsObject, keys, value);
  });

  return queryParamsObject;
}
